import React, { ReactNode } from 'react'
import UploadIcon from 'static/icons/upload_icon.svg'
import { Title } from 'app/components/ui/Title'
import styled from 'styled-components'

interface Props {
  title: string

  children: ReactNode
}

export const StepCard: React.FC<Props> = ({ title, children }) => {
  return (
    <StepCardWrapper>
      <TitleWrapper>
        <img src={UploadIcon} alt='upload'></img>
        <Title size={3}>{title}</Title>
      </TitleWrapper>
      {children}
    </StepCardWrapper>
  )
}

const StepCardWrapper = styled.div`
  text-align: center;

  display: flex;
  flex-direction: column;
`
const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 3rem;

  > * {
    margin-right: 1rem;
  }
`
